/**
 * Collection of helpers to Array objects
 */
var Arrays = {}

/**
 * Get the first object in a array with the value specifiqued
 * @param {Array} items Array
 * @param {String} field Field from Array
 * @param {String} value Filter Vaue
 */
function getItemBy (items, field, value) {
    var itemsL = items.length
    if (itemsL > 0) {
        if (typeof (items[0][field]) !== 'undefined') {
            for (var index = 0; index < items.length; index++) {
                if (items[index][field] === value) {
                    return items[index]
                }
            }
        }
    }
    return undefined
}

function clearSelect (arrayItem, item, callbackObject) {
    for (var i = 0; i < item.dependencies.length; i++) {
        for (var j = 0; j < arrayItem.length; j++) {
            if (arrayItem[j].name === item.dependencies[i]) {
                arrayItem[j].select_options = []
            }
        }
    }
    if (typeof (callbackObject) !== 'undefined') {
        for (var k = 0; k < callbackObject.functions.length; k++) {
            if (item.value !== '') {
                callbackObject.functions[k](callbackObject.arguments[k])
            }
        }
    }
}

/**
 * Create a array with a range
 * @param {Number} param1 - index or end of the range
 * @param {Number} [param2] - optional end of the range
 * @param {Number} [param3] - optional break for the range
 */
function range (param1, param2, param3) {
    let start = 0
    let end = 0
    let b = 1
    let items = []
    if (typeof (param2) === 'undefined') {
        end = param1
    } else {
        start = param1
        end = param2
    }
    if (typeof (param3) !== 'undefined' && param3 > 0) {
        b = param3
    }
    for (var index = start; index <= end; index = index + b) {
        items.push(index)
    }
    return items
}

Arrays.getItemBy = getItemBy
Arrays.clearSelect = clearSelect
Arrays.range = range

export { Arrays }



// WEBPACK FOOTER //
// ./src/helpers/index.js